export class MediaUseViewModel {
    public mediaMediaUseId: string;
    public mediaUseCode: string;
    public mediaUseName: string;
}